import { defineComponent } from 'vue';
import {  useNotification } from 'naive-ui';
import componentBase from '~/components/component-base';


export default defineComponent({

    extends: componentBase,

    data() {
        return {
            isLoading: false,
        }
    },

    mounted(): void {
        //@ts-ignore
        window.$notifications = useNotification();

        this.hideLoading();
        this.$router.beforeEach(() => {

            if(this.isLoading) {
                this.hideLoading();
            }

            this.showLoading();
            this.isLoading = true;
        });

        this.$router.afterEach(() => {
            this.hideLoading();
        })
    },
    
})